import React, { Component } from 'react';
import classNames from 'classnames';
import './../css/loaders.min.css';

export default class Loader extends Component {
  render() {
    return (
      <div className={classNames('loader_list', {'ball-pulse': this.props.show})} >
        <div/>
        <div/>
        <div/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/loader.js